import { render, staticRenderFns } from "./NeedsCenterDetail.vue?vue&type=template&id=a49a5146&scoped=true&"
import script from "./NeedsCenterDetail.vue?vue&type=script&lang=js&"
export * from "./NeedsCenterDetail.vue?vue&type=script&lang=js&"
import style0 from "./NeedsCenterDetail.vue?vue&type=style&index=0&id=a49a5146&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49a5146",
  null
  
)

export default component.exports